// TODO: в константы, и использовать вместе с scss
const mediaQueries = {
  mobile: window.matchMedia?.('(width < 744px)'),
  tablet: window.matchMedia?.('(744px <= width < 1280px)'),
  desktop: window.matchMedia?.('(width >= 1280px)'),
  touch: window.matchMedia?.('(pointer: coarse)'),
};

const features = {
  iosDevice: CSS.supports('-webkit-touch-callout: none'),
};

let provided = false;

const mediaQueryUnmountAbort = new AbortController();
function bindReactiveViewport(queryType: keyof typeof mediaQueries, provideKey?: string) {
  const mediaQuery = mediaQueries[queryType];
  if (!mediaQuery)
    return;

  const reactiveVar = ref(mediaQuery.matches);

  provideKey && provide(provideKey, readonly(reactiveVar));

  mediaQuery.addEventListener('change', (event: MediaQueryListEvent) => {
    reactiveVar.value = event.matches;
  }, { passive: true, signal: mediaQueryUnmountAbort.signal });

  return reactiveVar;
}

function bindSupportedFeatures(key: keyof typeof features, provideKey?: string) {
  const supportsFeature = features[key];
  provideKey && provide(provideKey, supportsFeature);
}

export function provideReactiveViewport() {
  if (provided)
    return;

  bindReactiveViewport('mobile', 'isMobileViewport');
  bindReactiveViewport('tablet', 'isTabletViewport');
  bindReactiveViewport('desktop', 'isDesktopViewport');
  bindReactiveViewport('touch', 'hasTouch');

  bindSupportedFeatures('iosDevice', 'isIosDevice');

  onBeforeUnmount(() => {
    provided = false;

    mediaQueryUnmountAbort?.abort();
  });

  provided = true;
}
